import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireDetailsModal } from "/Users/yvonne/Repositories/2. H1/Shopify-reisartikelen/theme/assets/details-modal.js";
var detailsModalExports = requireDetailsModal();
export { detailsModalExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(detailsModalExports);